import React from "react";
import '../../Styles/Sass/HomeHero.scss';
import '../../Styles/index.sass';
import '../../Images/Home/CC_PrimaryLogo_Colour.png';
import Navbar from '../Navbar'
import { Container, Row, Col } from 'reactstrap';

function HomeHero() {
  return (
      <Container inline className="contHomeHero image" >
            <Navbar/>
        <Row >
          <Col className="heroText" lg={6}>
            <section className="homeHero">
              <h6 className="homeHero__title">
                Make Your Building of <br></br>
                Home Stand Out
              </h6>
              <p className="homeHero__list">
                Simplify Hiring by choosing a hassle-free<br></br>
                quality cleaner or cleaning team
              </p>
              <button className='getStartedButton'>Explore Now</button>
              <p className="homeHero__list">
                Looking for a cleaning job? <a href="#">Sign Up</a>
              </p>
            </section>
          </Col>
          <Col lg={6}>

          </Col>
        </Row>
      </Container>

  );
}

export default HomeHero;

